import { API_FILE_URL } from '@/slw/shared/consts/common.const';
import { UploadedFile, UploadFilesPayload } from '@/slw/shared/types/file.type';

export const uploadFiles = async <TResult = UploadedFile[]>({
  files,
  applicationCode,
  moduleCode,
  functionCode,
}: UploadFilesPayload) => {
  const formData = new FormData();

  // Append multiple files
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }

  formData.append('applicationCode', applicationCode);
  formData.append('moduleCode', moduleCode);
  formData.append('functionCode', functionCode);

  return apiClient().upload<TResult>('/File/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    baseURL: API_FILE_URL,
  });
};
